<template>
  <div>
    <div class="sub">
      <div class="oLeft"></div>
      <div class="oRight" v-if="isShow">
        <div class="list">
          <el-table :data="info.orderData" highlight-current-row>
            <el-table-column label="序号" type="index"> </el-table-column>
            <el-table-column label="商品名称">
              <template slot-scope="scoped">
                {{ scoped.row.goods_name }}
              </template>
            </el-table-column>
            <el-table-column label="单价" prop="desk_price"> </el-table-column>
            <el-table-column label="数量/重量" prop="unit">
              <template slot-scope="scoped">
                {{ scoped.row.num }}{{ scoped.row.unit }}
              </template>
            </el-table-column>
            <el-table-column label="小计" prop="price">
              <template slot-scope="scoped">
                ￥{{ scoped.row.price }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="discounts">
          <div class="discountsAll">
            <span>不抹零</span>
            <span v-if="info.discount">折扣{{info.discount}}折</span>
            <span v-if="info.coupon">优惠劵-￥5.00</span>
          </div>
          <div class="discountsPrice">共优惠￥{{info.preferential}}</div>
        </div>
        <div class="price">
          <span style="font-size:32px;margin-left:20px">¥{{info.priceInfo.finalPrice}}</span>
          <span style="font-size:18px;margin-left:18px">合计：<i>￥{{info.priceInfo.totalPrice}}</i></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// const ipcRender = window.require("electron").ipcRenderer;

export default {
  name: "HelloWorld",
  data() {
    return {
      isShow:false,
      info: {
        coupon:0,
        discount:10,
        orderData: [],
        priceInfo:{},
         preferential:0
       
      },
      
    };
  },
  mounted() {
    // ipcRender.on("pay-start", (e, msg) => {
      console.log(msg);
      if(msg.orderData.length!=0){
        this.isShow = true
      }else{
        this.isShow = false
        this.info =  {
        coupon:0,
        discount:10,
        orderData: [],
        priceInfo:{},
         preferential:0
       
      }
      }
      this.info = msg;
    // });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
.sub {
  width: 100%;
  height: 100vh;
  background: red;
  display: flex;
}
.oLeft {
  flex: 1;
  height: 100vh;
  background: yellow;
}
.oRight {
  width: 492px;
  height: 100vh;
  background: #fff;
  .list {
    width: 100%;
    height: calc(100vh - 153px);
  }
  .discounts {
    width: 100%;
    padding: 12px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .discountsAll {
      span {
        display: inline-block;
        background: rgba(0, 191, 138, 0.08);
        color: @desk-font-color;
        font-size: 16px;
        padding: 8px;
        border-radius: 4px;
        border: 1px solid #bceee0;
      }
    }
    .discountsPrice {
      color: rgb(0, 191, 138);
      font-size: 16px;
      line-height: 100%;
    }
  }
  .price {
    width: calc(100% - 24px);
    margin: 0 auto;
    height: 70px;
     border-radius: 4px;
    background: @desk-color;
    position: relative;
    display: flex;
    align-items: center;
    color: #fff;
    i{
      font-style:normal;
      text-decoration:line-through;
    }
  }
  .price::after {
    content: "";
    width:100%;
    height: 4px;
    background: #00b181;
    position: absolute;
    bottom: 0;
    left: 0;
    border-radius: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hi.vue